import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { tableReportData } from "Pages/Admin/GlobalExecution/@signals"
import { useReportBackendApiPath } from "Pages/Admin/GlobalExecution/Reports/@hooks/index"


export default function useGlobalMultiple(selectedData, setSelectedRows) {
	const { showToast } = useToast()
	const { forceUrl, retryUrl } = useReportBackendApiPath()


	const msg = selectedData.length > 1
		? `these ${selectedData.length} reports`
		: 'the selected report'


	const handleStopMultipleExecutions = useCallback(() => {
		showToast.confirm(`Are you sure to stop ${msg}?`, {
			onSubmit: () => {
				showToast.promise(postSubmit(forceUrl, {
					reportExecutionID: selectedData.map(a => a.id_last_execution)
				}), {
					onFinish: () => {
						tableReportData.value = tableReportData.value.filter(e => !selectedData.map(a => a.id_last_execution).includes(e.id_last_execution))
					}
				})
			}
		})
		setSelectedRows([])
	}, [JSON.stringify(selectedData)])


	const handleRetryMultipleExecutions = useCallback(() => {
		const password = window.prompt('Enter password to retry executions:')
		if (password === null) return

		showToast.confirm(`Are you sure to retry ${msg}?`, {
			onSubmit: () => {
				showToast.promise(postSubmit(retryUrl, {
					idReportExecution: selectedData.map(a => a.id_last_execution),
					password
				}))
			}
		})
		setSelectedRows([])
	}, [JSON.stringify(selectedData)])


	return {
		handleStopMultipleExecutions,
		handleRetryMultipleExecutions,
	}
}